import { RESOURCE_NAME } from '@esentai/core/features/products/consts';
import { canCreate, canRead, canUpdate } from '@esentai/core/policy-dsl';

import { authorizeIf } from '@/features/currentUser/rbac';

export const canReadProducts = authorizeIf(canRead(RESOURCE_NAME));
export const canReadProduct = authorizeIf(canRead(RESOURCE_NAME));
export const canCreateProduct = authorizeIf(canCreate(RESOURCE_NAME));
export const canUpdateProduct = authorizeIf(canUpdate(RESOURCE_NAME));

// TODO set permission for campaign statistic
export const canReadProductsStatistics = () => true;
